import { Injectable } from '@angular/core'
import { SharedModule } from '@tv3/shared/shared.module'
import { Channel, ChannelNameTokens } from '@tokeet-frontend/tv3-platform'
import { ConnectionView } from '@tv3/store/connection/connection.view'
import { Observable, of } from 'rxjs'
import { Store } from '@ngrx/store'
import { LoadConnections, RefreshConnectionsForChannel } from '@tv3/store/connection/connection.actions'
import { delay, tap } from 'rxjs/operators'
import { BdcCreatePropertyDialogService } from '../channel-content/bdc/bdc-create-property-dialog/bdc-create-property-dialog.service'
import { BdcPropertyDetailDialogService } from '../channel-content/bdc/bdc-property-detail-dialog/bdc-property-detail-dialog.service'

@Injectable({
  providedIn: SharedModule,
})
export class PropertyContentHelperService {
  constructor(
    private store: Store<any>,
    private bdcContentDialog: BdcPropertyDetailDialogService,
    private bdcCreatePropertyDialog: BdcCreatePropertyDialogService
  ) {}

  createProperty(channel: Channel): Observable<any> {
    let action
    switch (channel.name) {
      case ChannelNameTokens.BookingAPI:
        action = this.bdcCreatePropertyDialog.open(channel).afterClosed()
        break
      default:
        action = of(null)
    }

    return action.pipe(
      tap(() =>
        this.store.dispatch(
          RefreshConnectionsForChannel({ channelName: channel.name, channelId: channel.id, silent: true })
        )
      ),
      delay(500), // wait for refreshing
      tap(() => this.store.dispatch(LoadConnections({})))
    )
  }

  openContentOverlay(channel: Channel, connection?: ConnectionView): Observable<any> {
    let action

    switch (channel.name) {
      case ChannelNameTokens.BookingAPI:
        action = this.bdcContentDialog.open(channel, connection).afterClosed()
        break
      default:
        action = of(null)
    }

    return action.pipe(
      tap(() =>
        this.store.dispatch(
          RefreshConnectionsForChannel({ channelName: channel.name, channelId: channel.id, silent: true })
        )
      ),
      delay(500), // wait for refreshing
      tap(() => this.store.dispatch(LoadConnections({})))
    )
  }
}
